module.exports = __webpack_public_path__ + "static/media/connector-logo_dbt.5bd85bbd.svg";